var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30868",
    "data-name": "Path 30868",
    d: "M0,0H48V48H0Z",
    fill: "#c7cdd1",
    opacity: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View_pin",
    "data-name": "View pin",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27808",
    "data-name": "Group 27808",
    transform: "translate(-1254.229 -188.066) rotate(-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_183",
    "data-name": "Union 183",
    transform: "translate(734 1044.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30920",
    "data-name": "Path 30920",
    d: "M752.738,1053.69v1.785H734l1.633-1.785Z",
    transform: "translate(-734 -1045.659)",
    fill: "#63ff9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30921",
    "data-name": "Path 30921",
    d: "M771.333,1059.038a9.807,9.807,0,0,1-17.408,0h-3.471l-1.106-1.276-2.008,1.276-1.749-1.276-1.7,1.276-1.713-1.276-1.811,1.276h-2.141l-3.471-3.641h18.961v-3.569H736.526l1.7-1.856h15.7a9.814,9.814,0,1,1,17.408,9.066Z",
    transform: "translate(-734.081 -1044.689)",
    fill: "#ffb063"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3061",
    "data-name": "Ellipse 3061",
    transform: "translate(765.229 1051.83)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3062",
    "data-name": "Ellipse 3062",
    cx: 2.677,
    cy: 2.677,
    r: 2.677,
    transform: "translate(-1.414)",
    fill: "#102d6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6998",
    "data-name": "Rectangle 6998",
    transform: "translate(734 1052.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27805",
    "data-name": "Group 27805"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30922",
    "data-name": "Path 30922",
    d: "M752.738,1053.69v1.785H734l1.633-1.785Z",
    transform: "translate(-734 -1053.69)",
    fill: "#4972f4"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.25273660e3eb0d3e7d9852571c6c4506.svg";
export { ForwardRef as ReactComponent };